<template>
    <CompassModal v-model:visible="showModal" size="small" @closed="handleClose">
        <template #header>
            <div class="dialog__icon--close">
                <CompassIconButton icon="close" @click="$emit('close')" />
            </div>
        </template>
        <template #default>
            <div class="dialog__default flex-column ai-center">
                <div class="icon flex-column ai-center jc-center">
                    <SaasIcon icon="quota" width="98" height="75" />
                </div>
                <h2 class="typographies-heading-h2">{{ title }}</h2>
                <p class="typographies-paragraph-medium-regular">{{ message }}</p>
            </div>
        </template>
        <template #footer>
            <span class="dialog__footer">
                <CompassButton
                    :label="$t.__('quotas.PopupQuotaLimit.contact_our_team')"
                    type="primary"
                    @click.prevent="onClickContact()"
                />
            </span>
        </template>
    </CompassModal>
</template>

<script>
import SaasIcon from 'vcomponents/common/SaasIcon.vue';

export default {
    name: 'PopupQuotaLimit',
    components: {
        SaasIcon,
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        message: {
            type: String,
            required: false,
            default: '',
        },
    },
    data() {
        return {
            showModal: true,
            overlay: null,
        };
    },
    methods: {
        /**
         * Temporarily only close popup
         */
        onClickContact() {
            this.handleClose();
            MySupport.getForm();
        },
        handleClose() {
            this.$emit('close');
            Panel.prototype.close();
        },
    },
};
</script>

<style lang="scss" scoped>
@use '~@sellsy/styleguide/src/_variables' as *;

.dialog {
    &__icon--close {
        display: flex;
        justify-content: flex-end;
        padding: 24px 32px 0 32px;
    }

    &__default {
        padding-bottom: 24px;
        p {
            margin: 0;
            text-align: center;
        }
    }

    &__footer {
        display: flex;
        justify-content: flex-end;
        padding: 0 32px 24px 32px;
    }
}
</style>
